import $ from "jquery";
import Api from "./api";
import Factory from "./fields/factory";
import Validation from "./validation";
import Logger from "./../common/logger";
import Notification from "./../common/notification";

const Form = (($) => {
  let isRecaptchaInitialized = false;

  const Listeners = [];

  const Status = {
    Loading: 0,
    Default: 1,
    Submitting: 2,
    Success: 3,
  };

  const Default = {
    inline: false,
    name: null,
    submitText: null,
    successMessage: null,
    successUrl: null,
    recaptcha: false,
    recaptchaKey: "6LdgkyQTAAAAAHi6Pi8-1RojKElsic8JkqWYII7c",
    recaptchaTheme: "light",
    buttonText: "Submit",
  };

  window.onIonRecaptchaLoad = () => {
    isRecaptchaInitialized = true;
    Listeners.forEach((func) => {
      func();
    });
  };

  class Form {
    constructor(element, config) {
      this._id = "ion_form_" + new Date().getTime();
      this._element = element;
      this._$element = $(element);
      this._form = null;
      this._data = null;
      this._fields = [];
      this._fieldMap = {};
      this._status = Status.Loading;
      this._config = {
        ...Default,
        ...$(this._element).data(),
        ...config,
      };

      this.load();
    }

    getID() {
      return this._id + "_" + this._data.form.formID;
    }

    load() {
      const self = this;

      if (!this._config.name) {
        Logger.warn("The name or is is not supplied for the form.");
      }

      Api.getForm(this._config.name)
        .done((data) => {
          this._status = Status.Default;
          this._data = data;
          if (this._config.inline) {
            this._form = this._element;
            this._button = document.createElement("button");
            this.bindEvents();
          } else {
            self.build(data);
          }
        })
        .fail(() => {
          Logger.error("Could not load form '" + this._config.name + "'");
        });
    }

    build(data) {
      const self = this;

      this._form = document.createElement("form");
      this._form.classList.add("ion-form");
      this._form.id = "form__" + this._data.form.slug;

      if (this._data.fields && $.isArray(this._data.fields)) {
        this._data.fields.forEach((metaField, index) => {
          let field = Factory.load(metaField);
          if (field) {
            self._fields.push(field);
            self._fieldMap[field.getSlug()] = self._fields.length - 1;
            field.setForm(self);
          }
        });
      }

      this.bindEvents(this._form);
      this.render();
    }

    render() {
      const self = this;
      const id = this._id + "_submit_btn";

      this._fields.forEach((field, index) => {
        field.render();
        self._form.appendChild(field.getElement());
      });

      this._label = document.createElement("label");
      this._label.htmlFor = id;
      this._label.classList.add("sr-only");
      this._label.innerText = "Submit";

      this._form.appendChild(this._label);

      if (this._config.recaptcha == 1 && window.grecaptcha) {
        this._recaptchaElement = document.createElement("div");
        this._recaptchaElement.style.marginBottom = "10px";
        this._form.appendChild(this._recaptchaElement);

        if (isRecaptchaInitialized) {
          this._recaptcha = window.grecaptcha.render(this._recaptchaElement, {
            sitekey: this._config.recaptchaKey,
            theme: this._config.recaptchaTheme,
          });
        } else {
          Listeners.push(() => {
            this._recaptcha = window.grecaptcha.render(this._recaptchaElement, {
              sitekey: this._config.recaptchaKey,
              theme: this._config.recaptchaTheme,
            });
          });
        }
      }

      this._button = document.createElement("button");
      this._button.id = id;
      this._button.type = "submit";
      this._button.innerText = this._config.buttonText;
      this._button.classList.add("ion-btn");
      this._form.appendChild(this._button);

      this._element.appendChild(this._form);
    }

    bindEvents() {
      const self = this;

      $(this._form).on("submit", (e) => {
        self.onSubmit(e);
      });
    }

    onSubmit(e) {
      const self = this;

      e.preventDefault();

      if (this._status != Status.Default) {
        return false;
      }

      let data = this.isValid();

      // Try to submit to server
      if (!data) {
        self.fail(data);
        this._status = Status.Default;
        return;
      }

      if (
        self._config.recaptcha == 1 &&
        window.grecaptcha &&
        window.grecaptcha.getResponse
      ) {
        if (!window.grecaptcha.getResponse(this._recaptcha)) {
          let notification = new Notification(
            "Form Submission Failed",
            "Please complete the Recpatcha to Submit the form.",
            "error",
            true
          );
          this._status = Status.Default;
          return;
        }
        //this._recaptchaElement.remove();
      }

      self.submitting();

      const additionalHeaders = {};
      const location = $(this._element).data("location");
      if (location) {
        additionalHeaders["X-ion-location"] = location;
      }

      Api.submitForm(this._data.form.formID, data, additionalHeaders)
        .done((data) => {
          self.success();
          self._status = Status.Default;
        })
        .fail((jqXhr, textStatus, errorThrown) => {
          let messages = [];
          if (jqXhr.status == 400) {
            // An erorr occurred read messages
            if (jqXhr.responseJSON) {
              messages = jqXhr.responseJSON;
            }
          } else {
            Logger.error(
              "Form submission failed unexpectedly for '" +
                this._data.form.name +
                "'"
            );
          }
          self.fail(messages);
          self._status = Status.Default;
        });
    }

    isValid() {
      const self = this;

      let data = {};

      if (this._config.inline) {
        return this.getData();
      }

      let validation = new Validation();

      this._fields.forEach((field, index) => {
        let slug = field.getSlug();
        let value = field.getValue();

        data[slug] = value;

        field.validate(validation);
      });

      let messages = validation.validate(data);

      if (messages.length > 0) {
        return false;
      }

      return data;
    }

    submitting() {
      this._status = Status.Submitting;
      if (this._button) {
        this._button.innerText = "Submitting...";
        this._button.classList.add("ion-form-btn-inactive");
      }
    }

    resetButton() {
      this._button.innerText = this._config.buttonText;
      this._button.classList.remove("ion-form-btn-inactive");
    }

    success(data) {
      if (!this._success) {
        this.renderSuccess();
      }

      this._form.style.display = "none";
      this._success.style.display = "block";

      this.resetButton();

      $(window).trigger("ion-form-submit-success", [
        {
          data: data,
          form: this._data.form,
        },
      ]);

      if (this._data.form.successUrl) {
        window.location = this._data.form.successUrl;
      }
    }

    fail(messages) {
      this.resetButton();

      $(window).trigger("ion-form-submit-fail", [
        {
          messages: messages,
          form: this._data.form,
        },
      ]);

      if (!messages || !typeof messages == "object") {
        return;
      }

      this._fields.forEach((field, index) => {
        let slug = field.getSlug();
        if (!messages[slug]) {
          return;
        }

        let fieldMessages = messages[slug];

        if ($.isArray(fieldMessages)) {
          fieldMessages.forEach((message) => {
            field.appendMessage(message);
          });
        } else {
          field.appendMessage(fieldMessages);
        }

        // TODO : Tell the field to refresh
      });

      let notification = new Notification(
        "Form Submission Failed",
        "Please review your entries.",
        "error",
        true
      );
    }

    renderSuccess() {
      let message =
        this._data.form.successMessage ||
        "<h3>Thank you for your inquiry!</h3>Your information has been submitted successfully.";

      this._success = document.createElement("div");
      this._success.classList.add("ion-form-success");
      this._success.innerHTML = message;
      this._success.style.display = "none";
      this._element.appendChild(this._success);
    }

    getData() {
      const self = this;

      let data = {};

      $("input,textarea,select", this._element).each((index, element) => {
        let $element = $(element);
        let name = element.name;
        let value = null;

        if (element.tagName == "INPUT") {
          if (element.type == "radio" || element.type == "checkbox") {
            if (element.checked === true) {
              value = $element.val();
            }
          } else {
            value = $element.val();
          }
        } else {
          value = $element.val();
        }

        if (value && value.trim().length > 0) {
          if (!data[name]) {
            data[name] = value;
          } else {
            if (!$.isArray(data[name])) {
              data[name] = [data[name]];
            }
            data[name].push(value);
          }
        }
      });

      return data;
    }
  }

  // Data API
  $("[data-ion='form']").each(function (index, element) {
    const $element = $(element);
    let data = $element.data("ion.form");

    if (!data) {
      data = new Form(element);
      $element.data("ion.form", data);
    }

    if (typeof config === "string") {
      if (typeof data[config] === "undefined") {
        throw new TypeError(`No method named "${config}"`);
      }
      data[config]();
    }
  });

  return Form;
})($);

export default Form;
